// extracted by mini-css-extract-plugin
module.exports = {"cart-wrapper":"Content_cart-wrapper__PGwmk","card-wrapper-vertical":"Content_card-wrapper-vertical__Ms_bs"};